import { render, staticRenderFns } from "./scroll-to-top.vue?vue&type=template&id=3e328038&scoped=true&"
import script from "./scroll-to-top.vue?vue&type=script&lang=js&"
export * from "./scroll-to-top.vue?vue&type=script&lang=js&"
import style0 from "./scroll-to-top.vue?vue&type=style&index=0&id=3e328038&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e328038",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlideYReverseTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VIcon,VSlideYReverseTransition})
